import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import { StbCustomRenderButtonComponent } from "../smart-table-customs/custom-render-button";
import { Receipt, ReceiptDetail } from "../../models/receipt.model";
import { StbCustomRenderDateComponent } from "../smart-table-customs/custom-render-date";
import { StbCustomRenderIdComponent } from "../smart-table-customs/custom-render-id";
import { StbCustomRenderCheckboxComponent } from "../smart-table-customs/custom-render-checkbox";
import * as moment from "moment";
import { Employee } from "../../models/employee.model";
import { convertTimestampsPipe } from "../../@core/utils/convertTimestamps.service";
import { ReceiptService } from "../../services/receipt.service";
import { DialogReceiptDeliveryComponent } from "../dialog-receipt-delivery/dialog-receipt-delivery.component";
import { NbDialogService } from "@nebular/theme";
import Shop from "../../models/shop.model";
import { DialogPrintReceiptsDeliveryComponent } from "../dialogs/dialog-print-receipts-delivery/dialog-print-receipts-delivery.component";

@Component({
  selector: "ngx-view-table-receipt-delivery",
  styleUrls: ["./view-table-receipt-delivery.component.scss"],
  templateUrl: "./view-table-receipt-delivery.component.html",
})
export class ViewTableReceiptDeliveryComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop;
  @Input() employeesDeliverer: Employee[] = [];
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";
  user: User;
  periodType = "day";
  periodDate: Date = moment().toDate();
  fromDate: Date = moment().startOf("day").toDate();
  toDate: Date = moment().endOf("day").toDate();

  employeeDeliveryId: string = "";
  employeeDeliveryName: string = "";
  isDelivered: string = "";

  receipts?: Receipt[] = [];
  receiptDeliverySubs: any;
  receiptDeliveries?: Receipt[] = [];
  receiptDetails?: ReceiptDetail[] = [];
  totalQuantity: number = 0;

  //ng2-smart-table config
  @Input() source: LocalDataSource = new LocalDataSource();
  // settings: any;
  settings = {
    hideHeader: false,
    noDataMessage: "",
    attr: {
      class: "table table-striped",
    },
    actions: {
      columnTitle: "",
      add: false,
      edit: false,
      delete: false,
    },
    columns: {},
  };

  constructor(
    private userService: UserService,
    private receiptService: ReceiptService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              isDelivered: {
                title: user.language == "en" ? "Delivered" : "Đã giao?",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderCheckboxComponent,
              },
              deliveryDate: {
                title: user.language == "en" ? "Date" : "Ngày giao",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderDateComponent,
              },
              deliveryNote: {
                title: user.language == "en" ? "Note" : "Ghi chú",
                type: "string",
              },
              employeeDeliveryName: {
                title: user.language == "en" ? "Delivery" : "Người giao",
                type: "string",
              },
              deliveredAmount: {
                title:
                  user.language == "en" ? "Delivered Amount" : "Chi phí giao",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              issueDate: {
                title: user.language == "en" ? "Date" : "Ngày HĐ",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderDateComponent,
              },
              id: {
                title: user.language == "en" ? "Code" : "Số phiếu",
                type: "custom",
                renderComponent: StbCustomRenderIdComponent,
              },
              customerName: {
                title: user.language == "en" ? "Customer" : "Khách hàng",
                type: "string",
              },
              customerMobile: {
                title: user.language == "en" ? "Mobile" : "Di động",
                type: "string",
              },
              totalAmount: {
                title: user.language == "en" ? "Amount" : "Tổng tiền",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              // employeeCounSellorName: {
              //   title: user.language == "en" ? "CounSellor" : "Tư vấn",
              //   type: "string",
              // },
            },
          };

          this.getReceiptDeliveries();
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectTime(value) {
    if (value) {
      this.periodDate = value.periodDate;
      this.fromDate = value.fromDate;
      this.toDate = value.toDate;
      this.periodType = value.type;

      console.log(
        `selectTime ${this.periodType}/ fromDate: ${this.fromDate}/ toDate: ${this.toDate}`
      );

      this.getReceiptDeliveries();
    }
  }

  changeEmployee(value) {
    if (value) {
      this.employeeDeliveryId = value.objectId;
      this.employeeDeliveryName = value.objectName;

      this.summaryReceipt();
    }
  }

  removeFilter(mode) {
    this.isDelivered = "";
    this.summaryReceipt();
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);
    this.viewDetailByDelivery(item);
  }

  printDelivery() {
    this.dialogService
      .open(DialogPrintReceiptsDeliveryComponent, {
        context: {
          shopId: this.shopId,
          shop: this.shop,
          uid: this.uid,
          user: this.user,
          receiptDetails: this.receiptDetails,
          totalQuantity: this.totalQuantity,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
        }
      });
  }

  private getReceiptDeliveries() {
    this.loading = true;
    if (this.receiptDeliverySubs) this.receiptDeliverySubs.unsubscribe();

    this.receiptDeliverySubs = this.receiptService
      .getReceiptDeliveries(this.shopId, this.fromDate, this.toDate)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            // issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          }))
        ),
        convertTimestampsPipe(),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (data) => {
          this.receipts = data;
          console.log("getReceiptDeliveries:", this.receipts);
          this.summaryReceipt();
          this.loading = false;
        },
        (err) => {
          this.receipts = [];
          this.loading = false;
          console.log("getReceiptDeliveries/err:", err);
        }
      );
  }

  summaryReceipt() {
    this.receiptDeliveries = [];
    this.receiptDetails = [];
    this.totalQuantity = 0;

    if (this.employeeDeliveryId) {
      this.receiptDeliveries = _.filter(this.receipts, {
        employeeDeliveryId: this.employeeDeliveryId,
      });
    } else {
      this.receiptDeliveries = _.clone(this.receipts);
    }

    if (this.isDelivered) {
      const isDelivered = this.isDelivered === "delivered" ? true : false;
      this.receiptDeliveries = _.filter(this.receiptDeliveries, {
        isDelivered: isDelivered,
      });
    }

    let customerId = "";
    const receiptCustomers = _.sortBy(this.receiptDeliveries, [
      "customerId",
      "issueDate",
    ]);
    _.forEach(receiptCustomers, (item) => {
      _.forEach(item.receiptDetails, (itemD) => {
        let expDetail: ReceiptDetail = new ReceiptDetail();
        expDetail = itemD;
        if (customerId !== item.customerId) {
          customerId = item.customerId;
          expDetail.receipt = item;
        } else {
          expDetail.receipt = null;
        }
        this.totalQuantity += itemD.quantity;
        this.receiptDetails.push(expDetail);
      });
    });

    this.source.load(this.receiptDeliveries);
  }

  private viewDetailByDelivery(item: Receipt) {
    this.dialogService
      .open(DialogReceiptDeliveryComponent, {
        context: {
          shopId: this.shopId,
          shop: this.shop,
          uid: this.uid,
          user: this.user,
          employeesDeliverer: this.employeesDeliverer,
          receipt: item,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
        }
      });
  }
}
